import { gql } from "@apollo/client";

export const SERVICE_STATUS=gql`query GetServiceStatus($serviceName: String!) {
    getServiceStatus(serviceName:$serviceName) {
        serviceName
        isActive
    }
}
`;

